/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".video-container[_ngcontent-%COMP%]{height:100%}.videoWrapper[_ngcontent-%COMP%]{position:absolute;padding-bottom:56.25%;height:0;top:50%;width:100%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.videoWrapper[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%}"];
export { styles as styles };
